export interface TranscriptEntry {
  speakerName: string
  speakerNum: number
  timestamp: string
  utterance: string
}

const UTTERANCE_REGEX = /<v (.*)>(.*)<\/v>|(.*): (.*)/
const DEFAULT_SPEAKER_NAME_REGEX = /spk_(\d)/
const VTT_HEADER_TOKEN = 'WEBVTT'

const parseSpeakerName = (name: string) => {
  const speakerNameParts = DEFAULT_SPEAKER_NAME_REGEX.exec(name)
  if (speakerNameParts && speakerNameParts.length === 2) {
    return `Speaker ${parseInt(speakerNameParts[1]) + 1}`
  } else {
    return name
  }
} 

const extractTimestamp = (timestampLine: string) => {
  const fullTimestamp = timestampLine.slice(3, 8)
  return fullTimestamp.startsWith('00') ? fullTimestamp.slice(1) : fullTimestamp
}

export const parseVTT = (vtt: string): TranscriptEntry[] => {
  const lines = vtt.split(/\n|\r\n/)
  if (lines[0] !== VTT_HEADER_TOKEN) {
    throw Error('Not a VTT file')
  }

  const includesLineNumbers = lines[2] === '1'
  const entries = []
  const speakers: string[] = []

  for (let i = (includesLineNumbers ? 3 : 2); i < lines.length; i += (includesLineNumbers ? 4 : 3)) {
    const utteranceParts = UTTERANCE_REGEX.exec(lines[i+1])
    if (utteranceParts && utteranceParts.length > 1) {

      const speakerName = parseSpeakerName(utteranceParts[1] || utteranceParts[3])
      let speakerNum = speakers.findIndex(speaker => speaker === speakerName)
      if (speakerNum === -1) {
        speakers.push(speakerName)
        speakerNum = speakers.length - 1
      }

      entries.push({
        timestamp: extractTimestamp(lines[i]),
        speakerName,
        speakerNum,
        utterance: utteranceParts[2] || utteranceParts[4]
      })
    }
  }

  return entries
}